import { Button, ButtonProps, DialogTrigger } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import React from 'react';

export type CloseButtonProps = ButtonProps;

export const CloseButton: React.FC<CloseButtonProps> = (props) => {
    return (
        <Button
            appearance="subtle"
            aria-label="Close"
            icon={<Dismiss24Regular />}
            {...props}
        />
    );
};

export const CloseDialogButton: React.FC = () => {
    return (
        <DialogTrigger action="close">
            <CloseButton />
        </DialogTrigger>
    );
};
